module.exports = __webpack_public_path__ + "assets/e81495b0f2a8f0212f5fb3a595e10ec6.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/BannerIntro2.mp3
 ** module id = 311
 ** module chunks = 0
 **/